export default __webpack_public_path__ + "static/media/boutique2.e6aa8f94.jpg";